import { render, staticRenderFns } from "./ResetPwd.vue?vue&type=template&id=7886486b&scoped=true&"
import script from "./ResetPwd.vue?vue&type=script&lang=js&"
export * from "./ResetPwd.vue?vue&type=script&lang=js&"
import style0 from "./ResetPwd.vue?vue&type=style&index=0&id=7886486b&lang=scss&scoped=true&"
import style1 from "./ResetPwd.vue?vue&type=style&index=1&id=7886486b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7886486b",
  null
  
)

export default component.exports